import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EntryGuideForm from '../../components/EntryGuides/EntryGuideForm';
import Toast from '../../components/Common/Toast';

const CreateEntryGuide = () => {
  const navigate = useNavigate();
  const { warehouseId } = useParams();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Guía de entrada creada exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      if (warehouseId) {
        navigate(`/warehouses/${warehouseId}/documents`);
      } else {
        navigate('/warehouses');
      }
    }, 1500);
  };

  const handleCancel = () => {
    if (warehouseId) {
      navigate(`/warehouses/${warehouseId}/documents`);
    } else {
      navigate('/warehouses');
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nueva Guía de Entrada</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para crear una nueva guía de entrada</p>
        </div>

        {/* Formulario */}
        <EntryGuideForm
          isOpen={true}
          onClose={handleCancel}
          entryGuide={null}
          warehouseId={warehouseId ? parseInt(warehouseId) : null}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default CreateEntryGuide;

